import { AlertCircle, LoaderCircle } from 'lucide-react';

import type { ChatMessage, ChatPosition } from '../types';
import { WidgetMessageText } from './message-text';

type ChatMessageProps = {
    message: ChatMessage;
    position: ChatPosition;
    showTime: boolean;
    onRetry: (id: string) => void;
};

const timeFormat = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
});

export function WidgetChatMessage({
    message,
    position,
    showTime,
    onRetry,
}: ChatMessageProps) {
    const outgoing = message.sender === 'customer';
    const failed = outgoing && message.status === 'failed';
    const sending = outgoing && message.status === 'sending';
    const groupStart = position === 'first' || position === 'solo';

    return (
        <div
            className={[
                'op-row',
                outgoing ? 'op-row-out' : '',
                groupStart ? 'op-group-start' : '',
            ]
                .filter(Boolean)
                .join(' ')}
        >
            <div className="op-bubble-wrap">
                <div
                    className={`op-bubble op-pos-${position} ${outgoing ? 'op-bubble-out' : 'op-bubble-in'}`}
                >
                    <WidgetMessageText text={message.text} />
                    {showTime && (
                        <div className="op-meta">
                            <span>{timeFormat.format(message.timestamp)}</span>
                        </div>
                    )}
                </div>
            </div>
            {outgoing && !failed && (
                <span
                    className="op-tick"
                    aria-hidden={sending ? undefined : true}
                >
                    {sending && <LoaderCircle aria-label="Sending" />}
                </span>
            )}
            {outgoing && failed && (
                <span className="op-tick-retry">
                    <AlertCircle aria-hidden="true" />
                    <button
                        type="button"
                        className="op-retry-btn"
                        aria-label="Not sent. Try again."
                        onClick={() => onRetry(message.id)}
                    >
                        Retry
                    </button>
                </span>
            )}
        </div>
    );
}
